const slick = require('slick-carousel');
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/style.css';

var ImageSlider = function(options) {

	this.options = {
		$el: false,
	};

	$.extend(true, this.options, options);

};

ImageSlider.prototype.init = function() {

	var self = this;
	var $track = self.options.$el.find('.comp-ImageSlider__track');

	if (!$track.length) return;

	var items = [];
	$track.find('.comp-ImageSlider__slide').each(function() {
		items.push({
			src: $(this).data('src'),
			width: parseInt($(this).data('width'), 10) || 1920,
			height: parseInt($(this).data('height'), 10) || 1080,
		});
	});

	$track.slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		infinite: true,
		arrows: false,
		dots: false,
		responsive: [
			{
				breakpoint: 1040,
				settings: {
					slidesToShow: 2,
				}
			},
			{
				breakpoint: 800,
				settings: {
					slidesToShow: 1,
				}
			}
		]
	});

	self.options.$el.find('.comp-ImageSlider__prev').on('click', function() {
		$track.slick('slickPrev');
	});

	self.options.$el.find('.comp-ImageSlider__next').on('click', function() {
		$track.slick('slickNext');
	});

	$track.on('afterChange', function(event, slick, currentSlide) {
		self.options.$el.find('.comp-ImageSlider__counter-current').text(currentSlide + 1);
	});

	$track.on('click', '.comp-ImageSlider__slide', function() {
		if (!items.length) return;

		var index = $track.slick('slickCurrentSlide');

		var pswp = new PhotoSwipe({
			dataSource: items,
			index: index,
		});

		pswp.on('bindEvents', function() {
			if (pswp.element) pswp.element.setAttribute('data-pswp-interactive', '');
		});

		pswp.init();
	});

};

export default ImageSlider;
